export enum DATA_QA {
  ROOT = 'sidebar-wrapper',
  CLOSE = 'sidebar-wrapper-close',
}
